import { createFileRoute } from '@tanstack/react-router'
import { PersonalInvitation } from '@/features/wedding-web/pages/personal-invitation'
export const Route = createFileRoute('/svatba/p/$partyToken')({ component: Page })
function Page() {
  return <PersonalInvitation partyToken={Route.useParams().partyToken} />
}
